<script>
import DayAndFrequency from "@/components/_Shared/OrdersAndSubscriptions/DayAndFrequency";
import Period from "@/components/_Shared/OrdersAndSubscriptions/Period";
import Professionals from "@/components/_Shared/OrdersAndSubscriptions/Professionals";

import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("newPurchase", [
      "day_of_week",
      "frequency",
      "start_at",
      "end_at",
      "professionals"
    ])
  },

  components: {
    DayAndFrequency,
    Period,
    Professionals
  }
};
</script>

<template>
  <div class="section" id="PerSchedule">
    <div class="section-title">ESCOLHA O DIA E A FREQUÊNCIA DA LIMPEZA
      <hr>
    </div>

    <div class="section-body">
      <transition name="fade" mode="out-in">
        <DayAndFrequency id="day_and_frequency" class="mt-20"/>
      </transition>

      <transition name="fade" mode="out-in">
        <Period class="mb-40" v-show="day_of_week && frequency"/>
      </transition>

      <transition name="fade" mode="out-in">
        <Professionals
          v-show="professionals.length && day_of_week && frequency && start_at && end_at"
          title="ESCOLHA UM PROFISSIONAL"
          @scrollTo="$emit('scrollTo', $event)"
        />
      </transition>
    </div>
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Subscription/NewSubscription/PerSchedule.vue